var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "card",
      class: _vm.classList,
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.$router.push({
            name: "helpDetail-" + _vm.$i18n.locale,
            params: { slug: _vm.data.slug }
          })
        }
      }
    },
    [
      _c("div", {
        staticClass: "category-card__hover",
        attrs: { "data-hovered": "true" }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "category-card__inner" },
        [
          _c(
            "div",
            { staticClass: "category-card__icon-wrapper" },
            [
              _c("v-card-icon", {
                attrs: {
                  backgroundPosition: _vm.data.backgroundPosition,
                  iconName: _vm.data.iconName
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("v-typo", {
            staticClass: "category-card__headline",
            attrs: { variant: "h3" },
            domProps: { innerHTML: _vm._s(_vm.data.headline) }
          }),
          _vm._v(" "),
          _vm.data.type === _vm.categoryVariants.ARTICLE
            ? _c("v-typo", {
                staticClass: "category-card__label",
                attrs: { variant: "body-perex" },
                domProps: {
                  innerHTML: _vm._s(
                    _vm.getArticlesCountInCagegory +
                      " " +
                      _vm.$t("common.articles")
                  )
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "category-card__link",
              attrs: {
                to: {
                  name: "helpDetail-" + _vm.$i18n.locale,
                  params: { slug: _vm.data.slug }
                }
              }
            },
            [
              _c("v-typo", {
                staticClass: "category-card__link-label",
                attrs: { variant: "body-perex" },
                domProps: { innerHTML: _vm._s(_vm.$t("common.browse")) }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }